import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { updateActiveChipSaga } from './updateActiveChipSaga';

export function* activeChipRootSaga() {
  yield all([takeEvery(ACTIONS.UPDATE_ACTIVE_CHIP, updateActiveChipSaga)]);
}
